var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('svg-icon',{staticStyle:{"font-size":"16px","margin-right":"2px"},attrs:{"icon-class":"shoppingCart"}}),_vm._v("购物车("+_vm._s(_vm.count)+")")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }